import Vue from 'vue'
import Vuex from 'vuex'
import * as Types from './mutation-types'
import userInfo from './module/user-info'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    userInfo
  },
  state: {
    paySelector: {
      visible: false,
      selectorPromise: null
    },
    userAddressObj: {
      userName: '',
      userPhone: '',
      userAddress: [], // ['上海市', '静安区', '静安寺'],
      userAddressIds: [], // ['省ID', '市ID', '区ID'],
      userAddressDetail: ''
    },
    ticketObj: {},
    orderConfirmConfig: {
      showAddress: true,
      showRemark: true
    },
    orderTicket: [],
    orderGoodsInfo: {
      goodsId: 0,
      name: '',
      icon: '',
      price: null,
      count: 1,
      isCouponUnAvaliable: false, // 是否能用优惠券（true表示禁用，false表示不禁用）
      isIntegralUnAvaliable: false, // 是否能用积分（true表示禁用，false表示不禁用）
      remark: '',
      goodsType: 2
    },
    orderListItemDetail: {},
    payStatus: {
      price: '',
      status: 'success',
      goodsId: 0
    },
    innerWebView: {
      src: ''
    },
    orderId: null
  },
  getters: {
    getUserAddressObj (state) {
      return state.userAddressObj
    },
    getTicketCount (state) {
      let count = 0
      Object.values(state.ticketObj).forEach(item => {
        count += item.useable
      })
      return count
    },
    getTicketSelectCount (state) {
      let count = 0
      Object.values(state.ticketObj).forEach(item => {
        count += item.useable === false
      })
      return count
    },
    getTicketList (state) {
      let list = Object.values(state.ticketObj).sort(function (a, b) {
        return parseInt(a.price) < parseInt(b.price)
      })
      return list
    },
    [Types.ORDER_TICKET] (state) {
      return state.orderTicket.sort(function (a, b) {
        return parseInt(a.price) < parseInt(b.price)
      })
    },
    getOrderGoodsInfo (state) {
      return state.orderGoodsInfo
    },
    getOrderListItemDetail (state) {
      return state.orderListItemDetail
    },
    getPayStatus (state) {
      return state.payStatus
    },
    getPaySelectorVisible (state) {
      return state.paySelector.visible
    },
    getPaySelectorPromise (state) {
      return state.paySelector.selectorPromise
    },
    getOrderConfirmConfig (state) {
      return state.orderConfirmConfig
    },
    getOrderId (state) {
      return state.orderId
    }
  },
  actions: {
    setUserAddressObj ({commit}, addressObj) {
      commit('setUserAddressObj', addressObj)
    },
    setPayStatus ({commit}, obj) {
      commit('setPayStatus', obj)
    },
    setInnerWebView ({commit}, src) {
      commit('setInnerWebView', src)
    },
    [Types.ORDER_TICKET] ({commit}) {
      // 只是从ticketObj准换成数组即可
      commit(Types.ORDER_TICKET)
    },
    openPaySelector ({commit}) {
      commit('setPaySelectorVisible', true)
      let promiseFunc = (resolve) => {
        commit('setSelectorPromise', resolve)
      }
      return new Promise(promiseFunc).then(userSelect => {
        commit('setPaySelectorVisible', false) // 关闭选择框
        commit('setSelectorPromise', null) // 清理掉promise
        return userSelect
      })
    }
  },
  mutations: {
    setUserAddressObj (state, {userName, userPhone, userAddress, userAddressIds, userAddressDetail}) {
      state.userAddressObj = {
        userName,
        userPhone,
        userAddress,
        userAddressIds,
        userAddressDetail
      }
    },
    setTicketObj (state, ticketObj) {
      state.ticketObj = ticketObj
    },
    takeTicket (state, {id, couponCode}) {
      if (id in state.ticketObj) {
        state.ticketObj[id]['useable'] = false
        state.ticketObj[id]['couponCode'] = couponCode
      }
    },
    setOrderGoodsInfo (state, obj) {
      state.orderGoodsInfo = obj
    },
    setOrderListItemDetail (state, obj) {
      state.orderListItemDetail = obj
    },
    setPayStatus (state, obj) {
      state.payStatus = obj
    },
    [Types.ORDER_TICKET] (state) {
      let result = Object.values(state.ticketObj)
      state.orderTicket = result
    },
    setInnerWebView (state, src) {
      state.innerWebView.src = src
    },
    setPaySelectorVisible (state, value) {
      state.paySelector.visible = value
    },
    setSelectorPromise (state, obj) {
      state.paySelector.selectorPromise = obj
    },
    // 清理掉其他业务设置的优惠券
    cleanOrderTicket (state) {
      state.ticketObj = {}
    },
    // 设置，订单确认页配置信息
    setOrderConfirmConfig (state, config) {
      state.orderConfirmConfig = {
        ...state.orderConfirmConfig,
        ...config
      }
    },
    // 重置，订单确认页配置信息
    resetOrderConfirmConfig (state) {
      state.orderConfirmConfig = {
        showAddress: true,
        showRemark: true
      }
    },
    setOrderId (state, id) {
      state.orderId = id
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js